<!-- 小箱装大箱管理 -->
<template>
    <div class="container">
        <div class="header">
            <Input
                class="w300 mr24 mb24"
                type="text"
                v-model="storePrams.qrcode_number"
                placeholder="请输入或扫描溯源码查询"
            ></Input>
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.big_box_number"
                placeholder="请输入或扫描大箱码查询"
            ></Input>
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.small_box_number"
                placeholder="请输入或扫描小箱码查询"
            ></Input>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.batch_id"
                clearable
                filterable
                placeholder="请选择关联批次"
            >
                <Option
                    v-for="item in batchList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.batch_name }}</Option
                >
            </Select>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.product_id"
                clearable
                filterable
                placeholder="请选择关联产品"
            >
                <Option
                    v-for="item in productList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.product_name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearch"
                >确定搜索</Button
            >
        </div>
        <div class="content">
            <div>
                <Button
                    class="theme-bc mr24 mb24 theme-default-color"
                    @click="goPacking"
                    >小箱装入大箱</Button
                >
                <Button class="mr24 mb24" type="primary" ghost @click="goRepair"
                    >补充小箱到大箱</Button
                >
                <Button
                    class="mr24 mb24"
                    type="primary"
                    ghost
                    @click="goUnpacking"
                    >拆码出箱（拆大箱操作）</Button
                >
                <Table
                    ref="selection"
                    :columns="columnsTable"
                    :data="dataTable"
                    border
                    @on-selection-change="changeSelection"
                >
                    <template slot-scope="{ row }" slot="small_num">
                        <div>
                            <Button @click="goDetails(row)">{{
                                row.small_num
                            }}</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="product_nums">
                        <div>
                            <Button @click="goProduct(row)">{{
                                row.product_nums
                            }}</Button>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sb">
                            <Button type="success" ghost @click="goPacking(row)"
                                >装箱</Button
                            >
                            <Button
                                type="primary"
                                ghost
                                @click="goUnpacking(row)"
                                >拆箱</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox
                        class="checkbox-ml"
                        v-model="del_value"
                        @on-change="handleSelectAll"
                        >全选</Checkbox
                    >
                    <span class="mr24 ml24"
                        >已经选择{{ delData.length }}个</span
                    >
                    <Button type="error" ghost @click="goDel">拆箱</Button>
                </div>
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>

        <!-- 大箱中小箱列表 -->
        <Drawer v-model="detailsDrawer" :title="detailsTitle" width="80">
            <Table :columns="columnsDetails" :data="dataDetails" border>
                <template slot-scope="{ row }" slot="small_box_number">
                    <div>{{ row.small_box_number }}</div>
                </template>
                <template slot-scope="{ row }" slot="count">
                    <div>
                        <Button @click="goInfo(row)">{{
                            row.count ? row.count : 0
                        }}</Button>
                    </div>
                </template>
            </Table>
            <div class="page-drawer">
                <Page
                    :current="pageDetails.page"
                    :page-size="pageDetails.limit"
                    :total="totalDetails"
                    show-elevator
                    show-total
                    @on-change="changeDetails"
                />
            </div>
        </Drawer>
        <!-- 大箱中产品列表 -->
        <Drawer v-model="productDrawer" :title="productTitle" width="80">
            <Table :columns="columnsProduct" :data="dataProduct" border>
                <template slot-scope="{ row }" slot="show_product_imgs">
                    <div v-if="row.product_qrcode" class="flex-c">
                        <img
                            class="table-img"
                            v-if="row.product_qrcode.product"
                            :src="
                                row.product_qrcode.product.show_product_imgs[0]
                            "
                        />
                    </div>
                </template>
                <template slot-scope="{ row }" slot="product_name">
                    <div v-if="row.product_qrcode">
                        {{
                            row.product_qrcode.product
                                ? row.product_qrcode.product.product_name
                                : ""
                        }}
                    </div>
                </template>
                <template slot-scope="{ row }" slot="specs">
                    <div v-if="row.product_qrcode">
                        {{
                            row.product_qrcode.product
                                ? row.product_qrcode.product.specs
                                : ""
                        }}
                    </div>
                </template>
            </Table>
            <div class="page-drawer">
                <Page
                    :current="pageProduct.page"
                    :page-size="pageProduct.limit"
                    :total="totalProduct"
                    show-elevator
                    show-total
                    @on-change="changeProduct"
                />
            </div>
        </Drawer>
        <!-- Drawer -->
        <Drawer
            v-model="drawerModal"
            :title="drawerTitle"
            width="66"
            :styles="styles"
            :mask-closable="false"
        >
            <!-- 小箱装入大箱 -->
            <template v-if="drawerId == 2">
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                    @submit.native.prevent
                >
                    <div class="drawer-header">
                        <img
                            class="wh24 mr12"
                            src="../../assets/information.png"
                        />
                        <div style="color: #ff761d">
                            为了简化操作，如果小箱已装过大箱，执行该操作，小箱会重新绑定到新的大箱码中。（当需要拆箱重新分箱装货的场景时，免除了拆箱操作）
                        </div>
                    </div>
                    <FormItem label="录入大箱码：">
                        <div class="dis-flex">
                            <Input
                                class="w30 mr24"
                                type="text"
                                v-model="formData.big_box_number"
                                placeholder="录入已有外箱码或随机生成一个外箱码"
                            />
                            <Button type="success" @click="getPackingCountRound"
                                >随机生成</Button
                            >
                            <Button
                                class="theme-bc ml24 theme-default-color"
                                @click="goSelectCode"
                                >选择箱码</Button
                            >
                        </div>
                    </FormItem>
                    <FormItem label="录入方式：">
                        <RadioGroup
                            v-model="formData.type"
                            type="button"
                            @on-change="changeFilter"
                        >
                            <Radio label="1">录入小箱码</Radio>
                            <Radio label="2">筛选小箱码</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="录入小箱码：">
                        <div class="dis-flex">
                            <Input
                                @input="handleInputChange"
                                class="w30 mr24"
                                type="textarea"
                                v-model="qrcode_number"
                                :autosize="{ minRows: 10 }"
                                placeholder="录入小箱码，一行一个，支持手动和扫码枪扫码录入"
                            ></Input>
                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                "
                            >
                                <div>支持手动和扫码枪扫码录入。</div>
                                <div
                                    style="
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                    "
                                    @click="setNull"
                                >
                                    <img
                                        src="@/assets/blank.png"
                                        alt=""
                                        style="
                                            display: block;
                                            margin-right: 6px;
                                        "
                                    />
                                    <div>置空</div>
                                </div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
                <div class="drawer-footer">
                    <Button
                        class="theme-bc theme-default-color"
                        @click="submitDrawer"
                        @keyup.enter.native.prevent
                        >确定装箱</Button
                    >
                </div>
            </template>
            <!-- 补充小箱到大箱 -->
            <template v-if="drawerId == 3">
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                    @submit.native.prevent
                >
                    <div class="drawer-header">
                        <img
                            class="wh24 mr12"
                            src="../../assets/information.png"
                        />
                        <div style="color: #ff761d">
                            为了简化操作，如果小箱已装过大箱，执行该操作，小箱会重新绑定到新的大箱码中。（当需要拆箱重新分箱装货的场景时，免除了拆箱操作）
                        </div>
                    </div>
                    <FormItem label="录入大箱码：">
                        <div class="dis-flex">
                            <Input
                                class="w30 mr24"
                                type="text"
                                v-model="formData.big_box_number"
                                placeholder="录入已有大箱码"
                            />
                            <Button
                                class="theme-bc theme-default-color"
                                @click="goSelectCode"
                                >选择箱码</Button
                            >
                        </div>
                    </FormItem>
                    <FormItem label="录入方式：">
                        <RadioGroup
                            v-model="formData.type"
                            type="button"
                            @on-change="changeFilter"
                        >
                            <Radio label="1">录入小箱码</Radio>
                            <Radio label="2">筛选小箱码</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="录入小箱码：">
                        <div class="dis-flex">
                            <Input
                                @input="handleInputChange"
                                class="w30 mr24"
                                type="textarea"
                                v-model="qrcode_number"
                                :autosize="{ minRows: 10 }"
                                placeholder="录入小箱码，一行一个，支持手动和扫码枪扫码录入"
                            ></Input>
                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                "
                            >
                                <div>支持手动和扫码枪扫码录入。</div>
                                <div
                                    style="
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                    "
                                    @click="setNull"
                                >
                                    <img
                                        src="@/assets/blank.png"
                                        alt=""
                                        style="
                                            display: block;
                                            margin-right: 6px;
                                        "
                                    />
                                    <div>置空</div>
                                </div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
                <div class="drawer-footer">
                    <Button
                        class="theme-bc theme-default-color"
                        @click="submitDrawer"
                        @keyup.enter.native.prevent
                        >确定装箱</Button
                    >
                </div>
            </template>
            <!-- 拆码出箱(拆大箱操作) -->
            <template v-if="drawerId == 4">
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                    @submit.native.prevent
                >
                    <FormItem label="录入方式：">
                        <RadioGroup v-model="formData.type" type="button">
                            <Radio label="2">小箱码拆箱</Radio>
                            <Radio label="4">大箱码拆箱</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="录入小箱码：">
                        <div class="dis-flex">
                            <Input
                                @input="handleInputChange"
                                class="w30 mr24"
                                type="textarea"
                                v-model="qrcode_number"
                                :autosize="{ minRows: 10 }"
                                placeholder="录入小箱码，一行一个，支持手动和扫码枪扫码录入"
                            ></Input>
                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                "
                            >
                                <div>支持手动和扫码枪扫码录入。</div>
                                <div
                                    style="
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;
                                    "
                                    @click="setNull"
                                >
                                    <img
                                        src="@/assets/blank.png"
                                        alt=""
                                        style="
                                            display: block;
                                            margin-right: 6px;
                                        "
                                    />
                                    <div>置空</div>
                                </div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
                <div class="drawer-footer">
                    <Button class="mr24" @click="cancelDrawer">取消</Button>
                    <Button
                        class="theme-bc theme-default-color"
                        @click="submitDrawer"
                        @keyup.enter.native.prevent
                        >确定</Button
                    >
                </div>
            </template>
        </Drawer>
        <!-- 选择箱码 -->
        <Drawer
            v-model="selectCodeModal"
            title="选择箱码"
            width="66"
            :styles="styles"
        >
            <Select
                class="w200 mr24 mb24"
                v-model="pageCode.product_id"
                clearable
                filterable
                placeholder="关联产品"
            >
                <Option
                    v-for="item in productList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.product_name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearchCode"
                >确定搜索</Button
            >
            <Table :columns="columnsCode" :data="dataCode" border></Table>
            <div class="page-drawer">
                <Page
                    :current="pageCode.page"
                    :page-size="pageCode.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChangeCode"
                />
            </div>
            <div class="drawer-footer">
                <Button class="mr24" @click="cancelCode">取消</Button>
                <Button class="theme-bc theme-default-color" @click="submitCode"
                    >确定</Button
                >
            </div>
        </Drawer>
        <!-- 筛选小箱码 -->
        <Drawer
            v-model="filterModal"
            title="筛选小箱码"
            width="66"
            :styles="styles"
            @on-close="closeFilter"
        >
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="pageFilter.start_id"
                placeholder="起始ID"
            ></Input>
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="pageFilter.end_id"
                placeholder="截止ID"
            ></Input>
            <Button
                class="theme-bc mb24 theme-default-color"
                icon="ios-search"
                @click="goSearchFilter"
                >确定搜索</Button
            >
            <Table
                ref="selection"
                :columns="columnsFilter"
                :data="dataFilter"
                border
                @on-selection-change="changeSelectionFilter"
            >
                <template slot-scope="{ row }" slot="count">
                    <div>
                        {{ row.small_box_pack ? row.small_box_pack.count : "" }}
                    </div>
                </template>
            </Table>
            <div class="page-drawer">
                <Page
                    :current="pageFilter.page"
                    :page-size="pageFilter.limit"
                    :total="totalFilter"
                    show-elevator
                    show-total
                    @on-change="pageChangeFilter"
                />
            </div>
            <div class="drawer-footer">
                <Button class="mr24" @click="cancelFilter">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitFilter"
                    >确定</Button
                >
            </div>
        </Drawer>
        <!-- 小箱详情 -->
        <Drawer v-model="infoModal" title="小箱详情" width="66">
            <Table :columns="columnsInfo" :data="dataInfo" border>
                <template slot-scope="{ row }" slot="product_imgs">
                    <div v-if="row.product_qrcode" class="flex-c">
                        <img
                            class="table-img"
                            v-if="row.product_qrcode.product"
                            :src="
                                row.product_qrcode.product.show_product_imgs[0]
                            "
                        />
                    </div>
                </template>
                <template slot-scope="{ row }" slot="product_name">
                    <div v-if="row.product_qrcode">
                        {{
                            row.product_qrcode.product
                                ? row.product_qrcode.product.product_name
                                : ""
                        }}
                    </div>
                </template>
                <template slot-scope="{ row }" slot="specs">
                    <div v-if="row.product_qrcode">
                        {{
                            row.product_qrcode.product
                                ? row.product_qrcode.product.specs
                                : ""
                        }}
                    </div>
                </template>
                <template slot-scope="{ row }" slot="qrcode_number">
                    <div v-if="row.product_qrcode">
                        {{
                            row.product_qrcode.product
                                ? row.product_qrcode.qrcode_number
                                : ""
                        }}
                    </div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <Button type="warning" ghost @click="goUnpackingTip(row)"
                        >拆箱</Button
                    >
                </template>
            </Table>
            <div class="page-drawer">
                <Page
                    :current="pageInfo.page"
                    :page-size="pageInfo.limit"
                    :total="totalInfo"
                    show-elevator
                    show-total
                    @on-change="changeInfo"
                />
            </div>
        </Drawer>
    </div>
</template>

<script>
import {
    packing_big_list,
    packing_big_tostart,
    packing_count_round,
    packing_big_small,
    packing_big_product,
    packing_filter,
    packing_unpack,
    packing_small_product,
    batch_select,
    product_select,
} from "@/api/index";
export default {
    data() {
        return {
            qrcode_number: "",
            big_box_number: "",
            storePrams: {
                page: 1,
                limit: 10,
                qrcode_number: "",
                batch_id: "",
                small_box_number: "",
                big_box_number: "",
                product_id: "",
            },
            total: 0,
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { type: "index", width: 60, align: "center" },
                { title: "大箱码编码", key: "big_box_number", align: "center" },
                { title: "箱内小箱数量", slot: "small_num", align: "center" },
                {
                    title: "箱内产品数量",
                    slot: "product_nums",
                    align: "center",
                },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            batchList: [],
            productList: [],
            drawerModal: false,
            drawerTitle: "",
            drawerId: 0,
            detailsDrawer: false,
            detailsTitle: "",
            pageDetails: {
                page: 1,
                limit: 10,
                big_box_number: "",
            },
            totalDetails: 0,
            columnsDetails: [
                { type: "index", width: 60, align: "center" },
                { title: "小箱码", slot: "small_box_number", align: "center" },
                { title: "箱内产品数量", slot: "count", align: "center" },
            ],
            dataDetails: [],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            formData: {
                qrcode_number: [],
                big_box_number: "",
                is_round: 0,
                is_exist: 0,
                type: "1",
            },
            productDrawer: false,
            productTitle: "",
            pageProduct: {
                page: 1,
                limit: 10,
                big_box_number: "",
            },
            totalProduct: 0,
            columnsProduct: [
                { type: "index", width: 60, align: "center" },
                { title: "图片", slot: "show_product_imgs", align: "center" },
                { title: "产品名称", slot: "product_name", align: "center" },
                { title: "规格", slot: "specs", align: "center" },
                { title: "产品编码", key: "qrcode_number", align: "center" },
            ],
            dataProduct: [],
            styles: {
                height: "calc(100% - 55px)",
                overflow: "auto",
                paddingBottom: "53px",
                position: "static",
            },
            selectCodeModal: false,
            dataCode: [],
            pageCode: {
                page: 1,
                limit: 10,
                product_id: "",
            },
            filterModal: false,
            pageFilter: {
                page: 1,
                limit: 10,
                start_id: "",
                end_id: "",
            },
            totalFilter: 0,
            columnsFilter: [
                { type: "selection", width: 60, align: "center" },
                { title: "ID号", key: "id", align: "center" },
                { title: "小箱码", key: "qrcode_number", align: "center" },
                { title: "箱内产品数量", slot: "count", align: "center" },
            ],
            dataFilter: [],
            filter_data: "",
            pageInfo: {
                page: 1,
                limit: 10,
            },
            totalInfo: 0,
            columnsInfo: [
                { type: "index", width: 60, align: "center" },
                { title: "图片", slot: "product_imgs", align: "center" },
                { title: "产品名称", slot: "product_name", align: "center" },
                { title: "规格", slot: "specs", align: "center" },
                { title: "产品编码", slot: "qrcode_number", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataInfo: [],
            infoModal: false,
            selectedId: null, // 存储选中的ID
        };
    },
    mounted() {
        this.getList();
        this.getBatchSelect();
        this.getProductSelect();
    },
    computed: {
        columnsCode() {
            return [
                {
                    title: "选择",
                    width: 100,
                    render: (h, params) => {
                        return h("Checkbox", {
                            props: {
                                value: this.selectedId === params.row.id,
                            },
                            on: {
                                "on-change": () => this.selectRow(params.row),
                            },
                        });
                    },
                },
                { title: "小箱码", key: "small_box_number", align: "center" },
                { title: "大箱码", key: "big_box_number", align: "center" },
                { title: "箱内产品数量", key: "product_nums", align: "center" },
            ];
        },
    },
    methods: {
        selectRow(e) {
            this.selectedId = e.id;
            this.formData.big_box_number = e.big_box_number;
        },
        changeInfo(index) {
            this.pageInfo.page = index;
            this.goInfo();
        },
        // 详情
        goInfo(row) {
            packing_small_product({ small_box_number: row.small_box_number })
                .then((res) => {
                    this.dataInfo = res.data.data;
                    this.totalInfo = res.data.total;
                    this.infoModal = true;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getFilter() {
            packing_filter(this.pageFilter)
                .then((res) => {
                    this.dataFilter = res.data.data;
                    this.totalFilter = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        changeSelectionFilter(e) {
            this.filter_data = e
                .map((item) => item.qrcode_number) // 提取所有值
                .filter((code) => code && code.trim()) // 过滤空值
                .filter((code, index, self) => self.indexOf(code) === index) // 去重
                .join("\n");
        },
        pageChangeFilter(index) {
            this.pageFilter.page = index;
            this.getFilter();
        },
        goSearchFilter() {
            this.pageFilter.page = 1;
            this.getFilter();
        },
        submitFilter() {
            if (this.qrcode_number) {
                this.qrcode_number += "\n" + this.filter_data;
            } else {
                this.qrcode_number += this.filter_data;
            }
            if (!this.filter_data) {
                this.$Message.error("请选择小箱码");
                return;
            }
            this.formData.type = "1";
            this.filterModal = false;
        },
        cancelFilter() {
            this.formData.type = "1";
            this.filterModal = false;
        },
        closeFilter() {
            this.formData.type = "1";
        },
        changeFilter(e) {
            if (e == 2) {
                this.pageFilter.page = 1;
                this.pageFilter.limit = 10;
                this.pageFilter.start_id = "";
                this.pageFilter.end_id = "";
                this.getFilter();
                // 延时器
                setTimeout(() => {
                    this.filterModal = true;
                }, 300);
            }
        },
        submitCode() {
            if (!this.formData.big_box_number) {
                this.$Message.error("请选择大箱码");
                return;
            }
            this.selectCodeModal = false;
        },
        cancelCode() {
            this.selectCodeModal = false;
        },
        getCode() {
            packing_big_list(this.pageCode)
                .then((res) => {
                    this.dataCode = res.data.data;
                    this.total = res.data.total.length
                        ? res.data.total[0].nums
                        : "";
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChangeCode(index) {
            this.pageCode.page = index;
            this.getCode();
        },
        goSearchCode() {
            this.pageCode.page = 1;
            this.getCode();
        },
        goSelectCode() {
            this.getCode();
            this.selectCodeModal = true;
        },
        goUnpackingTip(row) {
            var qrcode_number = row.qrcode_number
                .split("\n")
                .map((item) => (item === "" ? null : item)) // 将空字符串转为 null
                .filter((item) => item !== null); // 过滤掉所有 null 值
            this.$Modal.confirm({
                title: "是否将此溯源码拆出！",
                content: "将此溯源码从小箱中拆出",
                onOk: () => {
                    var data = {
                        type: 1,
                        qrcode_number: qrcode_number,
                    };
                    packing_unpack(data)
                        .then((res) => {
                            this.goInfo(row);
                            this.getPackingBigSmall();
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        setNull() {
            this.qrcode_number = "";
            this.formData.qrcode_number = [];
        },
        getList() {
            packing_big_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total.length
                        ? res.data.total[0].nums
                        : "";
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 大箱中小箱列表
        getPackingBigSmall() {
            packing_big_small(this.pageDetails)
                .then((res) => {
                    this.dataDetails = res.data.data;
                    this.totalDetails = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 大箱中产品列表
        getPackingBigProduct() {
            packing_big_product(this.pageProduct)
                .then((res) => {
                    this.dataProduct = res.data.data;
                    this.totalProduct = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 批次下拉
        getBatchSelect() {
            batch_select()
                .then((res) => {
                    this.batchList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 产品下拉
        getProductSelect() {
            product_select()
                .then((res) => {
                    this.productList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        changeDetails(index) {
            this.pageDetails.page = index;
        },
        changeProduct(index) {
            this.pageProduct.page = index;
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        goDetails(row) {
            this.big_box_number = row.big_box_number;
            this.pageDetails.big_box_number = row.big_box_number;
            this.getPackingBigSmall();
            this.detailsTitle = this.big_box_number + "大箱详情";
            setTimeout(() => {
                this.detailsDrawer = true;
            }, 300);
        },
        goProduct(row) {
            this.big_box_number = row.big_box_number;
            this.pageProduct.big_box_number = row.big_box_number;
            this.getPackingBigProduct();
            this.productTitle = this.big_box_number + "大箱详情";
            setTimeout(() => {
                this.productDrawer = true;
            }, 300);
        },
        goPacking() {
            this.formData.is_exist = 0;
            this.formData.qrcode_number = [];
            this.formData.big_box_number = "";
            this.formData.is_round = 0;
            this.qrcode_number = "";
            this.drawerTitle = "小箱装入大箱";
            this.drawerId = 2;
            this.drawerModal = true;
        },
        goRepair() {
            this.formData.is_exist = 0;
            this.formData.qrcode_number = [];
            this.formData.big_box_number = "";
            this.formData.is_round = 0;
            this.qrcode_number = "";
            this.drawerTitle = "补充小箱到大箱";
            this.drawerId = 3;
            this.drawerModal = true;
        },
        goUnpacking(row) {
            if (row.id) {
                this.formData.type = "4";
                this.qrcode_number = row.big_box_number;
            } else {
                this.formData.type = "2";
                this.qrcode_number = "";
            }
            this.formData.qrcode_number = [];
            this.drawerTitle = "拆码出箱(拆大箱操作)";
            this.drawerId = 4;
            this.drawerModal = true;
        },
        goDel() {
            if (this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "拆码出箱！",
                content: "将大箱码从大箱中拆出",
                onOk: () => {
                    var del_id = [];
                    this.delData.forEach((item) => {
                        del_id.push(item.big_box_number);
                    });
                    this.del_id = del_id.join(",");
                    var data = {
                        type: 4,
                        big_box_number: this.del_id,
                    };
                    packing_unpack(data)
                        .then((res) => {
                            this.getList();
                            this.del_value = false;
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
        getPackingCountRound() {
            this.formData.is_round = 1;
            packing_count_round()
                .then((res) => {
                    this.formData.big_box_number = res.data;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 确定
        submitDrawer() {
            if (this.qrcode_number) {
                this.formData.qrcode_number = this.qrcode_number
                    .split("\n")
                    .map((item) => (item === "" ? null : item)) // 将空字符串转为 null
                    .filter((item) => item !== null); // 过滤掉所有 null 值
            }
            // 拆码出箱(拆箱操作)
            if (this.drawerId == 4) {
                if (this.formData.type == 2) {
                    var data = {
                        type: this.formData.type,
                        small_box_number: this.formData.qrcode_number,
                    };
                } else if (this.formData.type == 4) {
                    var data = {
                        type: this.formData.type,
                        big_box_number: this.formData.qrcode_number,
                    };
                }
                packing_unpack(data)
                    .then((res) => {
                        this.getList();
                        this.drawerModal = false;
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
                return;
            }
            if (this.drawerId == 3) {
                this.formData.is_exist = 1;
            } else {
                this.formData.is_exist = 0;
            }
            var data = {
                is_exist: this.formData.is_exist,
                is_round: this.formData.is_round,
                qrcode_number: this.formData.qrcode_number,
                big_box_number: this.formData.big_box_number,
            };
            packing_big_tostart(data)
                .then((res) => {
                    if(res.data.code == 101){
                        this.$Modal.confirm({
                            content: res.msg,
                            onOk: () => {
                                this.formData.is_exist = 1;
                                this.submitDrawer();
                            },
                            onCancel: () => {},
                        });
                        return
                    }
                    this.getList();
                    this.drawerModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelDrawer() {
            this.drawerModal = false;
        },
        handleInputChange(e) {
            // 获取当前输入框的值
            const inputValue = e.target ? e.target.value : e;
            // 按换行符分割为数组（处理多行输入）
            const lines = inputValue.split("\n");
            // 用于存储处理后的所有码
            const allCodes = [];
            // 同时匹配 ?q=xxx 和 #xxx 两种链接
            const urlPattern = /https?:\/\/[^\s]+?(?:\?q=|#)([\w\-.]+)/g;
            // 处理每一行数据
            lines.forEach((line) => {
                // 处理行内的所有URL
                let match;
                let lastIndex = 0;
                const results = [];
                // 1. 提取行内所有URL的编码
                while ((match = urlPattern.exec(line)) !== null) {
                    // 添加URL前可能存在的非URL文本
                    if (match.index > lastIndex) {
                        const textBefore = line
                            .substring(lastIndex, match.index)
                            .trim();
                        if (textBefore) results.push(textBefore);
                    }
                    // 添加提取到的编码（两种分隔符捕获结果都存在 match[1]）
                    results.push(match[1]);
                    // 更新lastIndex
                    lastIndex = match.index + match[0].length;
                }
                // 2. 添加最后一个URL后的剩余文本
                if (lastIndex < line.length) {
                    const textAfter = line.substring(lastIndex).trim();
                    if (textAfter) results.push(textAfter);
                }
                // 3. 处理没有URL的直接输入码
                if (results.length === 0) {
                    const directCodeMatch = line.match(/^([\w\-.]+)\s*$/);
                    if (directCodeMatch) {
                        results.push(directCodeMatch[1]);
                    } else {
                        results.push(line); // 保留原始行内容
                    }
                }
                // 收集当前行的所有结果
                allCodes.push(...results);
            });
            // 更新v-model绑定的数据（去除空行）
            this.qrcode_number = allCodes
                .filter((code) => code.trim() !== "")
                .join("\n");
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.drawer-header {
    margin-bottom: 12px;
    padding: 24px;
    display: flex;
    align-items: center;
}
.wh24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.page-drawer {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.table-img {
    margin: 12px 0;
    width: 60px;
    height: 60px;
    border-radius: 5px;
}
.w30 {
    width: 30vw;
}
.dis-flex {
    display: flex;
}
.checkbox-ml {
    margin-left: 20px !important;
}
.drawer-footer {
    padding: 12px 24px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    text-align: right;
    background: #fff;
}
::v-deep .ivu-input-search {
    background: #53c41a !important;
    border-color: #53c41a !important;
}
::v-deep .ivu-checkbox {
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    color: #ffffff;
    box-shadow: none;
    z-index: 1;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper {
    margin-right: 24px;
}
</style>